import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
// import "./TenderInfo.css";
import "./../../../assets/css/TenderInfo.css"
import { FaFilePdf } from "react-icons/fa";

function SAMSA1102025() {
const documents = [
      {
        title: "CARGO AND TOWAGE APPROVAL",
        modified: "2019/08/05  10.35 AM",
        items: [
          "Notification_of_intention_to_build_0.",
          "INNotification_of_intention_to_build_0.",
        ],
      },
      {
        title: "Casualty Report",
        modified: "2019/08/05  10.35 AM",
        items: [
          "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
          "INS-701-08-03 Container Inspection Form",
          "INS-701-09-01 Towage Inspection",
        ],
      },
    ];


  return (
    <>
      <div className="container max-1330 justify-content-xl-start">
      <div className="service-title font-700 mb-3 text-uppercase">
        APPOINTMENT OF A PANEL OF RESEARCH ORGANISATIONS FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF THREE (3) YEARS​ ​ ​
        {/* <span className="text-orange-ef3e33 font-400"> offences </span> */}
      </div>
     <div className="table-container">
      <table className="tender-table">
        <tbody>
          <tr>
            <td className="label">Name of Institution</td>
            <td className="value">
              <strong>South African Maritime Safety Authority (SAMSA)</strong>
            </td>
          </tr>
          <tr>
            <td className="label">Description</td>
            <td className="value">
              <strong>
                APPOINTMENT OF A PANEL OF RESEARCH ORGANISATIONS FOR THE SOUTH AFRICAN MARITIME SAFETY AUTHORITY (SAMSA) FOR A PERIOD OF THREE (3) YEARS
              </strong>
              <br />
              <a
                href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                <FaFilePdf style={{ marginRight: "5px" }} />
                SAMSA-110-2025-26_Panel of Researchers Final.pdf
              </a>
            </td>
          </tr>
          <tr>
            <td className="label">Bid number</td>
            <td className="value"><strong>SAMSA/110/2025/26</strong></td>
          </tr>
          <tr>
            <td className="label">Advert date</td>
            <td className="value"><strong>23/07/2025</strong></td>
          </tr>
          <tr>
            <td className="label">Closing Date</td>
            <td className="value"><strong>15/08/2025 at 11:00</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
      </div>

    </>
  );
}

export default SAMSA1102025;